import { authHeaders, getAuthBaseUrl } from './authApi';

const DEFAULT_ROOM_PRESET = {
  mode: 'regular',
  hidingDurationSeconds: 1800,
  huntingDurationSeconds: 1800,
  entryFeeShards: 0,
  roomNamePrefix: 'EVT-',
  minMembersTotal: 4,
};

export { DEFAULT_ROOM_PRESET };

export async function fetchAdminPvpCampaigns() {
  const base = getAuthBaseUrl();
  if (!base) return [];
  const res = await fetch(`${base}/api/admin/pvp/campaigns`, { headers: authHeaders() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !Array.isArray(data.campaigns)) {
    throw new Error(data.error || 'Failed to load campaigns');
  }
  return data.campaigns;
}

export async function fetchAdminPvpCampaign(campaignId) {
  const base = getAuthBaseUrl();
  if (!base) return null;
  const res = await fetch(`${base}/api/admin/pvp/campaigns/${encodeURIComponent(campaignId)}`, {
    headers: authHeaders(),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.campaign) {
    throw new Error(data.error || 'Campaign not found');
  }
  return data.campaign;
}

export async function fetchAdminCampaignStats(campaignId) {
  const base = getAuthBaseUrl();
  if (!base) return null;
  const res = await fetch(`${base}/api/admin/pvp/campaigns/${encodeURIComponent(campaignId)}/stats`, {
    headers: authHeaders(),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.stats) {
    throw new Error(data.error || 'Failed to load stats');
  }
  return data.stats;
}

export async function fetchCampaignLeaderboard(slug, limit = 100) {
  const base = getAuthBaseUrl();
  if (!base) return [];
  const res = await fetch(
    `${base}/api/pvp/campaigns/${encodeURIComponent(slug)}/leaderboard?limit=${limit}`,
  );
  const data = await res.json().catch(() => ({}));
  return res.ok && Array.isArray(data.leaderboard) ? data.leaderboard : [];
}

export async function fetchCampaignLobbyRooms(slug) {
  const base = getAuthBaseUrl();
  if (!base || !slug) return [];
  const res = await fetch(`${base}/api/pvp/rooms?campaign=${encodeURIComponent(slug)}`);
  const data = await res.json().catch(() => ({}));
  return res.ok && Array.isArray(data.rooms) ? data.rooms : [];
}

export async function createAdminPvpCampaign(payload) {
  const base = getAuthBaseUrl();
  if (!base) return { success: false, error: 'API unavailable' };
  const res = await fetch(`${base}/api/admin/pvp/campaigns`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    return { success: false, error: data.error || 'Create failed' };
  }
  return { success: true, id: data.id, slug: data.slug };
}

export async function updateAdminPvpCampaign(campaignId, patch) {
  const base = getAuthBaseUrl();
  if (!base) return { success: false, error: 'API unavailable' };
  const res = await fetch(`${base}/api/admin/pvp/campaigns/${encodeURIComponent(campaignId)}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(patch),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    return { success: false, error: data.error || 'Update failed' };
  }
  return { success: true, campaign: data.campaign };
}

export async function finalizeAdminPvpCampaign(campaignId) {
  const base = getAuthBaseUrl();
  if (!base) return { success: false, error: 'API unavailable' };
  const res = await fetch(`${base}/api/admin/pvp/campaigns/${encodeURIComponent(campaignId)}/finalize`, {
    method: 'POST',
    headers: authHeaders(),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    return { success: false, error: data.error || 'Finalize failed' };
  }
  return { success: true, leaderboard: data.leaderboard };
}

export function statusLabel(status, zh = true) {
  if (status === 'active') return zh ? '进行中' : 'Active';
  if (status === 'ended' || status === 'rewards_distributed') return zh ? '已结束' : 'Ended';
  return zh ? '草稿' : 'Draft';
}

export function formatIsoDate(iso, zh = true) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleString(zh ? 'zh-CN' : 'en-AU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(iso);
  }
}
